import React, { FC, MouseEvent } from 'react';
import classNames from 'classnames';

import PremiumRibbonIcon from 'components/Icons/PremiumRibbon';

import styles from './EditorialFeatureCard.module.scss';

export interface EditorialFeatureCardProps {
  displayTitle?: string;
  feedSuperheader?: string;
  imageUrl?: string;
  isPremium?: boolean;
  onClickLink: (event: MouseEvent<HTMLAnchorElement>) => void;
  permalink: string;
  small?: boolean;
  title: string;
}

const getFeatureCardClasses = (small: boolean) =>
  classNames({
    [styles.editorialFeatureCard]: true,
    'quiver-feature-card': true,
    'quiver-feature-card--small': small,
  });

const getFeatureCardTitleContainerClasses = (feedSuperheader?: string) =>
  classNames({
    'quiver-feature-card__title__container': true,
    'quiver-feature-card__title__container--hasSuperheader': feedSuperheader,
  });

export const EditorialFeatureCard: FC<EditorialFeatureCardProps> = ({
  displayTitle,
  feedSuperheader,
  imageUrl,
  isPremium = false,
  onClickLink,
  permalink,
  small = false,
  title,
}) => (
  <a className={getFeatureCardClasses(small)} href={permalink} onClick={onClickLink}>
    {isPremium ? <PremiumRibbonIcon /> : null}
    <div className="quiver-feature-card--inner" style={{ backgroundImage: `url(${imageUrl})` }} />
    <div className={getFeatureCardTitleContainerClasses(feedSuperheader)}>
      {feedSuperheader && !small ? (
        <div className="quiver-feature-card__superheader">{feedSuperheader}</div>
      ) : null}
      <h2 className="quiver-feature-card__title">{displayTitle || title}</h2>
    </div>
  </a>
);

export default EditorialFeatureCard;
